import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from '../../../components/button/Button'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { displayModal } from '../../reducers/modal/actions'
import { modalTypes } from '../../../enums/modalTypeEnum'
import { saveInteractions } from '../../gtm/utils/gtmCallback'
import { Grid } from '@material-ui/core'

const useStyle = makeStyles(
	(theme) =>
		(
			{
				...styles(theme),
				headerContainerLargeScreenStyle: {
					'& h1': {
						margin: '0 0 35px'
					}
				},
				headerContainerSmallScreenStyle: {
					'& h1': {
						margin: '0 0 15px'
					}
				},
				marginBtn: {
					marginBottom: 16
				}
			}
		)
)

interface AcceptingProps {
	requestsLength: number,
	treatedRequestsList?: boolean,
	fetchRequestsList?: () => void
}

type HeaderProps = AcceptingProps

const Header: React.FC<HeaderProps> = (
	{
		requestsLength,
		treatedRequestsList = false,
		fetchRequestsList
	}
) => {
	const classes = useStyle()
	const dispatch = useDispatch()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const titleClass: ClassValue = classNames(
		isLargeScreen ? classes.title2 : classes.title6,
		classes.colorBlue
	)

	const containerClass: ClassValue = classNames(
		isLargeScreen ? classes.headerContainerLargeScreenStyle : classes.headerContainerSmallScreenStyle
	)

	const newRequestBtnClass: ClassValue = classNames(
		'col-xs-12 col-md-3',
		{ [classes.marginBtn]: !isLargeScreen }
	)

	return (
		<Grid container item xs={12} className={containerClass}>
			<h1 className={classNames(titleClass, 'col-xs-12 col-md-9')}>
				{treatedRequestsList ?
					<FormattedMessage
						id="requests.titleTreated"
						defaultMessage="Vos demandes clôturées"
						description="Request treated title"
					/>
					:
					<FormattedMessage
						id="requests.title"
						defaultMessage="Vos demandes en cours"
						description="Request title"
					/>
				}

			</h1>

			{
				(!treatedRequestsList && requestsLength > 0) &&
				<div className={newRequestBtnClass}>
					<Button
						background="backgroundAccessibility"
						color="colorWhite"
						textStyle="text8"
						onClick={() => {
							saveInteractions(
								{
									category: 'Vos Demandes',
									action: 'Déposer une demande',
									label: 'Etape 0::Call to action'
								}
							)

							dispatch(displayModal(modalTypes.demandes, { callback: fetchRequestsList }))
						}}
					>
						<FormattedMessage
							id="requests.makeRequest.title"
							defaultMessage="Déposer une demande"
							description="Request button"
						/>
					</Button>
				</div>
			}
		</Grid>
	)
}

export default Header
